import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class MarkdownExportService {
  /**
   * Export document as raw markdown
   */
  exportToMarkdown(markdown: string): string {
    if (!markdown) return "";
    return markdown.trim();
  }

  /**
   * Normalize and clean markdown content
   */
  normalizeMarkdown(input: string): string {
    if (!input) return "";
    let md = String(input);

    // Unescape numbering inside headings: "# 1\. Title" -> "# 1. Title"
    md = md.replace(/^(#{1,6}\s+)(\d+)\\\.(\s|$)/gm, (_m, a: string, b: string, c: string) => `${a}${b}.${c}`);

    // Convert embedded HTML tables to GFM tables
    md = this._convertHtmlTablesToMarkdown(md);

    return md;
  }

  /**
   * Convert HTML tables embedded in markdown to GitHub Flavored Markdown tables
   */
  private _convertHtmlTablesToMarkdown(md: string): string {
    if (!/<table[\s>]/i.test(md)) return md;

    return md.replace(/<table[\s\S]*?<\/table>/gi, (tableHtml) => {
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(tableHtml, "text/html");
        const table = doc.querySelector("table");

        if (!table) return tableHtml;

        const rows = Array.from(table.querySelectorAll("tr"));
        if (!rows.length) return tableHtml;

        const getTexts = (row: HTMLTableRowElement, sel: string) =>
          Array.from(row.querySelectorAll(sel)).map((c) => (c.textContent || "").trim());

        const headerCells = getTexts(rows[0] as HTMLTableRowElement, "th");
        let header: string[];
        let start = 1;

        if (headerCells.length) {
          header = headerCells;
        } else {
          header = getTexts(rows[0] as HTMLTableRowElement, "td");
        }

        const headerLine = `| ${header.join(" | ")} |`;
        const sepLine = `| ${header.map(() => "---").join(" | ")} |`;
        const out: string[] = [headerLine, sepLine];

        for (let i = start; i < rows.length; i++) {
          const cells = getTexts(rows[i] as HTMLTableRowElement, "td");
          if (!cells.length) continue;
          out.push(`| ${cells.join(" | ")} |`);
        }

        return out.join("\n");
      } catch {
        return tableHtml;
      }
    });
  }
}
